<template>
    <div class="scrollable flex items-center"
        @mousedown="hover && mousedown($event)"
        @mousemove="! hover && mousemove($event)"
        @mouseleave="isDown = false"
        @mouseup="isDown = false"
    >
        <i class="material-icons cursor-pointer"
          v-show="hasScroll"
          :class="{ disabled: reachedBeginning }"
          @mousedown="scroll(-1)">
          chevron_left
        </i>
        <div class="hs no-scrollbar">
            <slot></slot>
        </div>
        <i class="material-icons cursor-pointer"
          v-show="hasScroll"
          :class="{ disabled: reachedEnd }"
          @mousedown="scroll(1)">
          chevron_right
        </i>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                isDown: false,
                startX: null,
                scrollLeft: null,
                slider: null,
                hover: null,
                scrollLeftPosition: 0,
                reachedBeginning: true,
                reachedEnd: false,
                hasScroll: false
            }
        },

        methods: {
            mousedown(e) {
                this.isDown = true;
                this.startX = e.pageX - this.slider.offsetLeft;
                this.scrollLeft = this.slider.scrollLeft;
            },
            mousemove(e) {
                if (! this.isDown) return;
                e.preventDefault();
                const x = e.pageX - this.slider.offsetLeft;
                const walk = x - this.startX;
                this.slider.scrollLeft = this.scrollLeft - walk;
            },
            scroll(direction) {
                let interval = null;
                this.changeScrollPosition(direction);
                let timeout = setTimeout(() => {
                    interval = setInterval(this.changeScrollPosition.bind(this, direction), 250);
                }, 250);
                document.addEventListener('mouseup', () => {
                    clearTimeout(timeout);
                    clearInterval(interval);
                }, { once: true });
            },
            changeScrollPosition(direction) {
                this.scrollLeftPosition = this.slider.scrollLeft + 200 * direction;
                this.reachedBeginning = false;
                this.reachedEnd = false;
                if (this.scrollLeftPosition < 0) {
                  this.scrollLeftPosition = 0;
                  this.reachedBeginning = true;
                }
                if (this.scrollLeftPosition > (this.slider.scrollWidth - this.slider.clientWidth)) {
                  this.scrollLeftPosition = this.slider.scrollWidth;
                  this.reachedEnd = true;
                }
                this.slider.scrollLeft = this.scrollLeftPosition;
            },
            setHasScroll() {
              this.hasScroll = this.slider && this.slider.scrollWidth > this.slider.clientWidth;
            }
        },

        mounted() {
            this.slider = this.$el.querySelector('.hs');
            this.hover = window.matchMedia('(min-width: 1024px)').matches;
            this.setHasScroll();
            window.addEventListener('resize', this.setHasScroll);
        }
    };
</script>

<style scoped lang="scss">
    .scrollable {
        max-width: 100vw;
    }

    .hs {
        display: grid;
        grid-gap: 10px;
        grid-template-columns: calc(5vw - 10px);
        grid-template-rows: 44px;
        grid-auto-flow: column;
        cursor: grab;
        overflow-x: scroll;
        padding-bottom: calc(.75 * 5vw);
        margin-bottom: calc(-.25 * 5vw);
        scroll-snap-type: none;
        scroll-behavior: smooth;

        @media (min-width: 1024px) {
            grid-gap: 12px;
            grid-template-columns: none;
            cursor: default;
        }

        @media (max-width: 1023px) {
            &::before, &::after {
                content: '';
                width: 10px;
            }
        }
    }

    .no-scrollbar {
        scrollbar-width: none;
        margin-bottom: 0;
        padding-bottom: 0;
    }

    .no-scrollbar::-webkit-scrollbar {
        display: none;
    }

    .material-icons {
        user-select: none;
        font-size: 40px;
        @media (max-width: 1023px) {
            display: none;
        }
        &.disabled {
          cursor: not-allowed;
          color: #ccc;
        }
    }
</style>
